import { Compile, type Validator } from "typebox/compile";
import { ASM_CONTRACT_SCHEMAS, type AsmContractName } from "./schemas.js";

const validators = Object.fromEntries(
	Object.entries(ASM_CONTRACT_SCHEMAS).map(([name, schema]) => [name, Compile(schema)]),
) as Record<AsmContractName, Validator>;

export interface ContractValidationError {
	path: string;
	message: string;
}

export type ContractValidationResult = { valid: true } | { valid: false; errors: ContractValidationError[] };

export function validateContract(name: AsmContractName, value: unknown): ContractValidationResult {
	const validator = validators[name];
	if (validator.Check(value)) return { valid: true };
	return {
		valid: false,
		errors: [...validator.Errors(value)].map((error) => ({ path: error.instancePath, message: error.message })),
	};
}

export function assertContract(name: AsmContractName, value: unknown): void {
	const result = validateContract(name, value);
	if (!result.valid) {
		throw new Error(
			`Invalid ${name} contract: ${result.errors.map((error) => `${error.path || "/"} ${error.message}`).join("; ")}`,
		);
	}
}
